import { Icon_Cog, Icon_Message, Icon_Person, Sidebar } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import useNavigation from "../../../../hooks/navigation";
import { useIsSharedWithMeEnabled } from "../../../../hooks/useProjectSharing";
import { useTeam } from "../../../../hooks/useTeams";
import { useTracker } from "../../../../hooks/useTracker";
import { NavGroup } from "../NavGroup/NavGroup";
import { NavItem } from "../NavItem/NavItem";

export const DashboardNavGroup = () => {
  const tracker = useTracker();
  const navigation = useNavigation();
  const { teamID } = useParams();

  const { teamData } = useTeam(teamID);
  const showViewLinkListing = !teamData?.addons?.syncForbidden && !teamData?.addons?.privateCloud;
  const isSharedWithMeEnabled = useIsSharedWithMeEnabled();
  const showSharedWithMe = showViewLinkListing && isSharedWithMeEnabled;

  if (!teamID) return null;

  return (
    <NavGroup>
      <Sidebar.ScrollContainer>
        {showSharedWithMe && (
          <NavItem name="shared-with-me" track={tracker.trackGoToSharedWithMe}>
            <Icon_Person />
            Shared with me
          </NavItem>
        )}
        {showViewLinkListing && (
          <NavItem name="review-links" track={tracker.trackGoToReviewLinks}>
            <Icon_Message /> Review links
          </NavItem>
        )}
      </Sidebar.ScrollContainer>
      <Sidebar.Space marginTop={"auto"} />
      <Sidebar.Item
        onClick={() => {
          navigation.goToTeamMembers({ teamID });
        }}
      >
        <Icon_Cog /> {"Settings"}
      </Sidebar.Item>
    </NavGroup>
  );
};
